import { PaymentRequestRedirectResponse } from 'core/services/api/payment/payment-dpp';
import { CurrencyStore } from 'core/stores/currency.store';
import { SiteConfigStore } from 'core/stores/site-config.store';
import { NumberUtils } from 'utils/number.utils';
import { PaymentRequestType } from './payment-request';

export class PaymentRequestMoment implements PaymentRequestType<PaymentRequestRedirectResponse> {

  get hasProfileDetails() {
    return (
      !!this.request.firstName &&
      !!this.request.name &&
      !!this.request.email
    );
  }

  get hasAccountDetails() {
    return (
      !!this.request.accountNumber &&
      !!this.request.accountBalance &&
      !!this.request.amountToPay &&
      !!this.request.dueDate
    );
  }

  // TODO: Improve typing on request object
  constructor(private request: any, private currencyStore: CurrencyStore) { }

  addValues(values: { [key: string]: number | string | undefined }) {
    this.request = {
      ...this.request,
      ...values
    }
    return this;
  }

  getDependantValues() {
    return Promise.resolve(this);
  }

  toPaymentRequestObject() {
    const {
      successReturnUrl,
      currencyCode,
      customerNumber,
      amount,
      countryName,
      accountNumber,
      // paymentAttribution,
      paymentMetaData
    } = this.request;
    const { paymentAttribution } = paymentMetaData;

    const key = crypto.randomUUID();

    return {
      transactionId: key,
      customerNumber: customerNumber,
      country: countryName,
      financialAccountNumber: accountNumber,
      channel: SiteConfigStore.channel(),
      businessUnit: SiteConfigStore.businessUnit(),
      amount: +amount,
      currency: currencyCode,
      paymentType: "OneTime",
      returnURL: encodeURI(successReturnUrl),
      paymentActionType: paymentAttribution
    }
  }

  toTokenRequestObject() {
    const { customerNumber, amount, accountNumber, location, paymentMetaData } = this.request;
    const amountNumber = +`${amount}`;
    const amountInCents = isNaN(amountNumber) ? 0 : NumberUtils.FormatToDecimal(amountNumber * 100, '0-0', '');
    const { paymentAttribution } = paymentMetaData;

    return {
      accountNumber: customerNumber,
      amount: `${amountInCents}`,
      customerId: customerNumber,
      customerRedirectUrl: location,
      clientReference: `${accountNumber}-${customerNumber}-ZA`,
      qrTags: [`jid=${paymentAttribution}`],
    };
  }

  handleResponse(response: PaymentRequestRedirectResponse) {
    window.location.replace(response.redirectUrl);
    return Promise.resolve(false)
  }
}